var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "26.2492mm",
    height: "9.4562mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 26249.2 9456.2",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1468.3 2936.8c-810.7,0 -1468.3,-657.6 -1468.3,-1468.4 0,-810.8 657.6,-1468.4 1468.4,-1468.4 810.8,0 1468.4,657.6 1468.4,1468.4 0,0.7 0,2 0,2.7 -1.4,809.9 -658.5,1465.7 -1468.4,1465.7 0,0 0,0 0,0l-0.1 0zm0 -2712c-688,0 -1246.1,558.1 -1246.1,1246.2 0,688.1 558.1,1246.2 1246.2,1246.2 688.1,0 1246.2,-558.1 1246.2,-1246.2 0,-688.1 -558.1,-1246.2 -1246.2,-1246.2l-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1468.3 6196.5c-810.7,-0.1 -1468.3,-657.7 -1468.3,-1468.4 0,-810.8 657.6,-1468.4 1468.4,-1468.4 810.8,0 1468.4,657.6 1468.4,1468.4 0,810.7 -657.6,1468.3 -1468.4,1468.3l-0.1 0.1zm0 -2712.1c-688,0 -1246.1,558.1 -1246.1,1246.1 0,688.1 558.1,1246.2 1246.2,1246.2 688.1,0 1246.2,-558.1 1246.2,-1246.2 0,-0.8 0,-1.7 0,-2.5 -1.4,-687.1 -559.1,-1243.6 -1246.2,-1243.6 0,0 0,0 0,0l-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1804.3 2119.3l-105.8 -357.2 -529.2 0 -108.5 357.2 -206.4 0 455.1 -1431.4 248.7 0 452.5 1431.4 -206.4 0zm-598 -529.2l444.5 0 -222.3 -740.8 -222.2 740.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1854.6 4654c84.9,71.4 134,176.6 134,287.5 0,11.7 -0.6,23.5 -1.7,35.2 0.8,10.7 1.3,21.5 1.3,32.3 0,121.2 -55,235.8 -149.5,311.6 -108,73 -235.6,112.1 -366,112.1 -12,0 -24.2,-0.4 -36.1,-1l-375.8 0.2 0 -1420.8 772.6 0 -23.8 161.4 -553 0 0 373.1 187.8 -0.1c16.2,-1.2 32.5,-1.8 48.6,-1.8 128.8,0 254.8,38.5 361.6,110.3zm-148.2 555.6c55.2,-50.2 86.7,-121.3 86.7,-195.8 0,-10.6 -0.6,-21.3 -1.9,-31.8 0.1,-3.7 0.2,-7.6 0.2,-11.3 0,-79.9 -36.1,-155.4 -98.1,-205.7 -65.8,-43.5 -143.1,-66.8 -222.1,-66.8 -8,0 -16.1,0.3 -24,0.7l-190.6 0.1 0 576.8 195.8 0c7.1,0.2 14.3,0.4 21.4,0.4 78.1,0 154.5,-23.2 219.4,-66.7l13.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1468.3 9456.2c-810.7,-0.2 -1468.3,-657.8 -1468.3,-1468.6 0,-810.8 657.6,-1468.4 1468.4,-1468.4 810.8,0 1468.4,657.6 1468.4,1468.4 0,810.8 -657.6,1468.4 -1468.4,1468.4l-0.1 0.2zm0 -2712.1c-688,-0.1 -1246.1,558 -1246.1,1246.1 0,688.1 558.1,1246.2 1246.2,1246.2 688.1,0 1246.2,-558.1 1246.2,-1246.2 0,-0.8 0,-1.8 0,-2.6 -1.4,-687.1 -559.1,-1243.6 -1246.2,-1243.6 0,0 0,0 0,0l-0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1923.3 8003.6c58.4,56.7 91.3,134.6 91.3,216 0,9.1 -0.4,18.3 -1.3,27.3 0,264.6 -185.2,404.8 -560.9,404.8l-391.6 0.1 0 -1420.8 336 0c16.2,-1 32.6,-1.6 48.8,-1.6 127,0 252.2,31.5 364,91.5 88.8,53 143.2,148.8 143.2,252.2 0,4.1 -0.1,8.3 -0.3,12.4 0.1,2.8 0.2,5.8 0.2,8.7 0,72.4 -27.5,142.1 -76.9,195 -49.9,54.1 -115.7,91.1 -187.8,105.9 87.2,12.7 169,50.5 235.5,108.4l-0.2 0.1zm-666.7 -616.4l0 444.5 214.3 0c5.3,0.2 10.7,0.3 15.9,0.3 67.1,0 132.7,-20.5 187.9,-58.6 50,-37.4 79.6,-96.3 79.6,-158.9 0,-3.4 -0.1,-7 -0.3,-10.4 0.7,-5.8 1,-11.6 1,-17.4 0,-62.8 -32.3,-121.3 -85.5,-154.6 -70.5,-30.5 -146.7,-46.4 -223.6,-46.4 -13.6,0 -27.5,0.5 -41,1.5l-148.3 0zm460.5 1058.4c58.6,-38.1 94,-103.3 94,-173.1 0,-7.6 -0.4,-15.2 -1.3,-22.8 0.4,-5.9 0.7,-12 0.7,-18 0,-71.8 -33.5,-139.6 -90.7,-183.1 -62.8,-41.6 -136.6,-63.9 -212,-63.9 -6,0 -12.1,0.1 -18.1,0.4l-233 0.1 0 510.6 195.8 0c9.5,0.4 19.3,0.7 28.8,0.7 81.6,0 162.3,-18.4 235.9,-53.7l-0.1 2.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2825.6,
    y: 1357.4,
    width: 5794.4,
    height: 222.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2825.6,
    y: 4617.1,
    width: 5794.4,
    height: 222.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2825.6,
    y: 7876.6,
    width: 5794.4,
    height: 222.2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "black",
    fillRule: "nonzero",
    points: "18391,6699.2 18391,8077.8 18200.5,8077.8 18200.5,6900.3 17880.4,7096.2 17795.7,6963.9 18224.3,6699.2 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M21735.3 6693.9c59.6,31 110,77.7 145.6,134.8 34.6,57.7 52.9,123.7 52.9,190.9 0,0.8 0,1.6 0,2.4 0,0.9 0,2.1 0,3.2 0,82.7 -20,164.2 -58.2,237.4 -46.6,89.7 -104.5,173.5 -172,248.8 -79.4,90 -198.4,214.4 -357.2,373.2l616.5 0 -21.2 158.8 -812.3 -0.1 0 -150.8c185.2,-190.5 314.9,-330.7 391.6,-418 64,-70.6 119.3,-149.1 164.1,-233 32.9,-63.5 50.2,-134.3 50.2,-206 0,-1.9 -0.1,-3.8 -0.1,-5.6 0.4,-4.2 0.5,-8.4 0.5,-12.5 0,-57.3 -21.9,-112.5 -61.2,-154.2 -41.7,-39.3 -96.9,-61.2 -154.2,-61.2 -4.1,0 -8.3,0.1 -12.5,0.4 -2.9,-0.2 -5.8,-0.2 -8.7,-0.2 -48.6,0 -96.5,11.9 -139.5,34.5 -50.7,30.4 -96.4,69 -134.9,113.8l-124.4 -97.9c50.7,-64.8 115,-118.2 187.9,-156.1 70.1,-34.8 147.5,-53 225.8,-53 1.4,0 3,0 4.4,0 1.9,0.1 3.9,0 5.8,0 73.4,0 145.7,17.3 211.1,50.3l0 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M18258.7 8890c-809.8,-1.6 -1465.7,-658.8 -1465.7,-1468.6 0,-810.8 657.6,-1468.4 1468.4,-1468.4 806.7,0 1462.7,651.1 1468.4,1457.8 0,3.4 0,7.2 0,10.6 0,810.8 -657.6,1468.4 -1468.4,1468.4 -0.7,0 -2,0 -2.7,0l0 0.2zm0 -2712c-686.6,-0.1 -1243.5,556.8 -1243.5,1243.4 0,686.7 556.9,1243.5 1243.5,1243.5 686.7,0 1243.5,-556.8 1243.5,-1243.5 -1.3,-686 -557.4,-1242.1 -1243.5,-1243.5l0 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M21521 8890c-810.7,-0.2 -1468.3,-657.8 -1468.3,-1468.6 0,-810.8 657.6,-1468.4 1468.4,-1468.4 806.7,0 1462.7,651.1 1468.4,1457.8 0,3.4 0,7.2 0,10.6 0,810.8 -657.6,1468.4 -1468.4,1468.4 0,0 0,0 0,0l-0.1 0.2zm0 -2712c-2.6,-0.1 -5.3,-0.1 -7.9,-0.1 -686.6,0 -1243.5,556.9 -1243.5,1243.5 0,686.7 556.9,1243.5 1243.5,1243.5 686.7,0 1243.5,-556.8 1243.5,-1243.5 0,-3.5 0,-7.1 0,-10.6 -7.1,-679 -556.6,-1227.4 -1235.6,-1233l0 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M24780.7 8890c-810.8,-0.2 -1468.4,-657.8 -1468.4,-1468.6 0,-810.8 657.6,-1468.4 1468.4,-1468.4 806.7,0 1462.7,651.1 1468.4,1457.8 0.1,2.6 0.1,5.5 0.1,8 0,811.4 -657,1469.7 -1468.4,1471.1l-0.1 0.1zm0 -2712c-686.6,-0.1 -1243.5,556.8 -1243.5,1243.4 0,686.7 556.9,1243.5 1243.5,1243.5 686.7,0 1243.5,-556.8 1243.5,-1243.5 -1.3,-686 -557.4,-1242.1 -1243.5,-1243.5l0 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M24973.8 6744.2c57.8,28.3 106.4,72.3 140.3,126.9 31.1,52.3 47.6,112.2 47.6,173.2 0,0.5 0,1 0,1.4 0.1,3.6 0.2,7.4 0.2,11 0,72.3 -25.4,142.5 -71.6,198.1 -52.8,55.2 -121.2,93 -195.9,108.4 84.7,5 164.7,40.8 224.9,100.5 56.4,57.8 87.9,135.3 87.9,216 0,5.6 -0.2,11.3 -0.5,16.9 0,0.4 0,0.9 0,1.3 0,75.7 -20.1,150.2 -58.2,215.6 -38.3,65.6 -95.5,118.3 -164.1,150.9 -75.2,33.9 -156.9,51.5 -239.4,51.5 -82.5,0 -164.2,-17.6 -239.4,-51.5 -71.4,-29.9 -134.3,-77.3 -182.7,-137.6l111.1 -105.8c40,42.7 87.7,77.7 140.3,103.2 49,22.1 102.3,33.9 156.1,34.3 4.1,0.2 8.4,0.3 12.5,0.3 70.8,0 139,-26.5 191.2,-74.3 47.7,-49.3 74.4,-115.3 74.4,-183.9 0,-3.9 -0.1,-8 -0.3,-11.9 0.9,-8.4 1.4,-16.8 1.4,-25.2 0,-63.7 -26.4,-124.5 -72.8,-168 -53,-36.7 -116.1,-56.4 -180.6,-56.4 -7.7,0 -15.4,0.3 -23.1,0.9l-103.2 0.1 23.8 -145.5 68.8 -0.1c2.5,0 5.2,0.1 7.8,0.1 63.1,0 124.2,-22.6 172.1,-63.6 45.8,-43.5 71.8,-104 71.8,-167.1 0,-4.3 -0.1,-8.7 -0.4,-12.9 0.2,-2.9 0.3,-5.9 0.3,-8.9 0,-55 -23.1,-107.4 -63.7,-144.5 -42.6,-36.2 -96.7,-56.1 -152.5,-56.1 -4.7,0 -9.5,0.2 -14.3,0.4 -47.3,3.4 -93.4,17 -134.9,39.8 -51,22.3 -97.7,53.7 -137.6,92.5l-100.5 -111.1c105.2,-103.4 246.7,-162.3 394.2,-163.9 2.6,-0.1 5.4,-0.2 8,-0.2 69.5,0 138.2,15.4 201,45l0 0.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 18150.3,
    y: 679.9,
    width: 222.2,
    height: 5384.3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 21409.9,
    y: 679.9,
    width: 222.2,
    height: 5384.3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 24669.6,
    y: 679.9,
    width: 222.2,
    height: 5384.3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "black",
    fillRule: "nonzero",
    points: "13644.4,2749 13644.4,3892 14755.6,3892 14755.6,4468.8 13644.4,4468.8 13644.4,5603.9 13004.1,5603.8 13004.1,4468.8 11908.7,4468.8 11908.7,3892 13012,3892 13012,2749 "
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc31);
export default __webpack_public_path__ + "static/media/ic_3_1.75d471bca568851606a61e51687990b9.svg";
export { ForwardRef as ReactComponent };